module.exports = __webpack_public_path__ + "img/crown.1e3d4be.jpg";